const apiResponseValidator = (responseObj) => {
  if (Object.prototype.hasOwnProperty.call(responseObj, 'data') && typeof responseObj.data === 'object') {
    return responseObj.data
  }
  return false
}
export default apiResponseValidator
